// 入住人管理
import fetch,{ postFrom } from '../utils/fetch';

// 获取查询条件
export function getConditions() {
  return fetch({
      method: 'GET',
      url: 'checkinPersion/listCondition'
  })
}

//查询解约协议列表
export function getList(params) {
  return fetch({
      method: 'GET',
      url: 'checkinPersion/getList',
      params
  })
}

// 添加入住人条件检索
export function addCondition() {
  return fetch({
      method: 'POST',
      url: 'checkinPersion/addCondition'
  })
}

// 添加入住人校验手机号
export function toAddCheckPhone(params) {
  return fetch({
      method: 'GET',
      url: 'checkinPersion/toAddCheckPhone',
      params
  })
}

// 获取图形验证码

export function getImgVerifycode() {
  return fetch({
      method: 'POST',
      url: 'checkinPersion/getImgVerifycode'
  })
}

// 发送短信验证码
/*
params:{
  phone:手机号，
  type:新签1，动态登陆5，
  imgId: 图形验证码id，
  imgVValue: 图形验证码值
}
*/
export function sendSmsVerifycodeUrl(params) {
  return fetch({
      method: 'GET',
      url: 'checkinPersion/sendSmsVerifycodeUrl',
      params
  })
}
// 验证短信验证码
/*
params:{
  phone,
  type:新签1，动态登陆5，
  vcode:短信验证码
}
*/
export function verifySmsVerifycode(params) {
  return fetch({
      method: 'GET',
      url: 'checkinPersion/verifySmsVerifycode',
      params
  })
}
// 添加入住人
export function addRenter(data) {
  return fetch({
      method: 'POST',
      url: 'checkinPersion/save',
      data
  })
}

// 获取入住人信息
export function checkinPersion(contractId) {
  return fetch({
      method: 'GET',
      url: 'checkinPersion/detail',
      params:{
        contractId
      }
  })
}

// 添加合住人
export function addSharer(data) {
  // return postFrom('checkinPersion/addSharer',data)
  return fetch({
    method: 'POST',
    url: 'checkinPersion/addSharer',
    data
  })
}

// 删除合住人
export function delSharer(data) {
  return postFrom('checkinPersion/delSharer',data)
}

// 查看历史租客 /

export function getHistory(contractId) {
  return postFrom('checkinPersion/history',{contractId:contractId})
}

// 校验身份证 获取生日
export function validIdCardNumber(certNumber) {
  return fetch({
      method: 'GET',
      url: 'checkinPersion/validIdCardNumber',
      params:{
        certNumber
      }
  })
}
